import { Avatar, Link, SxProps, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import ArrowLeft from '../../Images/ArrowNextBlue.svg';
import { TypographyVariants } from 'ThemeV2.0';
import { onEnterOrEscapeKeyDown } from 'Utils/accessibilityOnKeyDown';

interface ILinkArrowLeft {
  text: string;
  href: string;
  sx?: SxProps;
  imgSx?: SxProps;
  newWindow: boolean;
  variant?: TypographyVariants;
}

export const LinkArrowLeft2 = (props: ILinkArrowLeft) => {
  const navigate = useNavigate();

  const hrefHandler = () => {
    props.newWindow ? window.open(props.href) : navigate(props.href);
  };

  return (
    <Link
      tabIndex={0}
      width='max-content'
      display='flex'
      alignItems='center'
      onClick={hrefHandler}
      onKeyDown={onEnterOrEscapeKeyDown}
      sx={props.sx}
      underline='hover'
    >
      <Typography variant={props.variant ?? 'body5'} color={'primary'}>
        {props.text}
      </Typography>
      <Avatar
        alt={''}
        src={ArrowLeft}
        sx={{
          transform: 'rotate(180deg)',
          width: '20px',
          height: '20px',
          ...props.imgSx,
        }}
      />
    </Link>
  );
};
